import { DefaultVariant } from "./DefaultVariant";
import { MyMenuVariant } from "./MyMenuVariant";

interface TabBarProps {
  variant?: "default" | "my-menu";
}

export const TabBar = ({ variant = "default" }: TabBarProps) => {
  switch (variant) {
    case "my-menu":
      return <MyMenuVariant />;
    case "default":
    default:
      return <DefaultVariant />;
  }
};
